if (!customElements.get('price-range')) {
    customElements.define('price-range', class PriceRange extends HTMLElement {
      constructor() {
        super();

        
      }

      connectedCallback() {
        this.buildUI();
        window.addEventListener('resize', () => this.handleResize());
      }

      handleResize() {
        const newUI = this.getActiveFilterUI;

        // Only rebuild if actual DOM changed
        if (newUI !== this.activeUI) {
          this.buildUI();
        }
      }

      buildUI() {
        this.activeUI = this.getActiveFilterUI;

        this.rangeInput = this.activeUI.querySelectorAll(".range-input input");
        this.priceInput = this.activeUI.querySelectorAll(".price-input input");
        this.range = this.activeUI.querySelector(".price_slider .progress");

        this.max_range = [...this.rangeInput].find(input => input.name === "filter.v.price.lte")
        this.min_range = [...this.rangeInput].find(input => input.name === "filter.v.price.gte")

        this.initialize();
      }

   

     changeProgress(event){      
      
        let input_id, range_id, input, range;
        
        
        if(event.target.id.includes("_price-range")){
            range_id = event.target.id;
            input_id = range_id.replace("_price-range", "_price");
            input = document.getElementById(input_id);
            range = document.getElementById(range_id);
            input.value = range.value;
        }else{
            input_id = event.target.id;
            range_id = input_id.replace("_price", "_price-range");
            input = document.getElementById(input_id);
            range = document.getElementById(range_id);
            input.value = Math.min(input.value, input.max)
            range.value = input.value;
        }
        
        

    
        if(event.target.name === "filter.v.price.gte"){
            const opposite_id = range_id.replace("v.price.gte", "v.price.lte");
            const opposite_range =  document.getElementById(opposite_id);

            const range_max_value = opposite_range.value || opposite_range.max;

            const current_percentage = (parseInt(event.target.value)) / parseInt(opposite_range.max) * 100;
            const left_percentage = (parseInt(event.target.value)) / parseInt(range_max_value) * 100;

            range.max = range_max_value;
            input.max = range_max_value; 
            
            
            this.range.style.left = current_percentage + "%";
            range.style.width = range_max_value / opposite_range.max * 100 + "%"
            
        }
        if(event.target.name === "filter.v.price.lte"){
            const opposite_id = range_id.replace("v.price.lte", "v.price.gte");
            const opposite_range =  document.getElementById(opposite_id);

            const range_max_value = event.target.value || event.target.max;
            const range_min_value = opposite_range.value || opposite_range.min;

            const current_percentage = (parseInt(range_min_value)) / parseInt(event.target.max) * 100;
            const range_percentage = parseInt(event.target.value) / parseInt(event.target.max) * 100;

            
            range.min = range_min_value;
            input.min = range_max_value; 

            this.range.style.right = 100 - range_percentage + "%"; 
            range.style.width =  100 - current_percentage + "%" 
            
        }
      }  

     
      changeInput(event){
        const input_id = event.target.id;
        const range_id = input_id.replace("_price", "_price-range");

        const input = document.getElementById(input_id);
        const range = document.getElementById(range_id);

        var newevent = new Event('change');
        range.dispatchEvent(newevent);

      }

      initialRun(){
        let minVal = parseInt(this.priceInput[0].value),
            maxVal = parseInt(this.priceInput[1].value);
            if(minVal){
                this.rangeInput[0].value = minVal;
                const left_percentage = (parseInt(minVal) / parseInt(this.priceInput[1].max)) * 100;
                
                this.range.style.left = left_percentage + "%";
                
            }
            if(maxVal){
                this.rangeInput[1].value = maxVal;
                const range_percentage = parseInt(this.rangeInput[1].value) / parseInt(this.rangeInput[1].max) * 100;
                this.range.style.right = 100 - range_percentage + "%";
            }
            
      } 

      initialize() {

        this.initialRun();
        
        this.priceInput.forEach(input => {
            const debouncedChangeInput = debounce((e) => this.changeInput(e), 500);
            input.addEventListener("input", (e) => {
                this.changeProgress(e);
                return debouncedChangeInput(e);
            });
        });

        

        this.rangeInput.forEach(input => {
            input.addEventListener("input", e => this.changeProgress(e));
        });
      }

      get getActiveFilterUI() {
        return window.innerWidth <= 1023
          ? document.querySelector('[x-ref="filter-drawer"]')
          : document.querySelector('[x-ref="filter-sidebar"]') || document.querySelector('[x-ref="filter-drawer"]');
      }

      
    });
} 


/* if (!customElements.get('price-range')) {
    customElements.define('price-range', class PriceRange extends HTMLElement {
      constructor() {
        super();
        this.container = this.getActiveFilterUI
        this.rangeInput = this.container.querySelectorAll(".range-input input");
        this.priceInput = this.container.querySelectorAll(".price-input input");
        this.range = this.container.querySelector(".price_slider .progress");
        this.max_range = [...this.rangeInput].find(input => input.name === "filter.v.price.lte")
        this.min_range = [...this.rangeInput].find(input => input.name === "filter.v.price.gte")
        this.priceGap = 10;


        this.initialize(); 
        
      }


    
   

     changeProgress(event){      
      
        let input_id, range_id, input, range;
        
        
        if(event.target.id.includes("_price-range")){
            range_id = event.target.id;
            input_id = range_id.replace("_price-range", "_price");
            input = document.getElementById(input_id);
            range = document.getElementById(range_id);
            input.value = range.value;
        }else{
            input_id = event.target.id;
            range_id = input_id.replace("_price", "_price-range");
            input = document.getElementById(input_id);
            range = document.getElementById(range_id);
            input.value = Math.min(input.value, input.max)
            range.value = input.value;
        }
        
        

    
        if(event.target.name === "filter.v.price.gte"){
            const opposite_id = range_id.replace("v.price.gte", "v.price.lte");
            const opposite_range =  document.getElementById(opposite_id);

            const range_max_value = opposite_range.value || opposite_range.max;

            const current_percentage = (parseInt(event.target.value)) / parseInt(opposite_range.max) * 100;
            const left_percentage = (parseInt(event.target.value)) / parseInt(range_max_value) * 100;

            range.max = range_max_value;
            input.max = range_max_value; 
            
            
            this.range.style.left = current_percentage + "%";
            range.style.width = range_max_value / opposite_range.max * 100 + "%"
            
        }
        if(event.target.name === "filter.v.price.lte"){
            const opposite_id = range_id.replace("v.price.lte", "v.price.gte");
            const opposite_range =  document.getElementById(opposite_id);

            const range_max_value = event.target.value || event.target.max;
            const range_min_value = opposite_range.value || opposite_range.min;

            const current_percentage = (parseInt(range_min_value)) / parseInt(event.target.max) * 100;
            const range_percentage = parseInt(event.target.value) / parseInt(event.target.max) * 100;

            
            range.min = range_min_value;
            input.min = range_max_value; 

            this.range.style.right = 100 - range_percentage + "%"; 
            range.style.width =  100 - current_percentage + "%" 
            
        }
      }  

     
      changeInput(event){
        const input_id = event.target.id;
        const range_id = input_id.replace("_price", "_price-range");

        const input = document.getElementById(input_id);
        const range = document.getElementById(range_id);

        var newevent = new Event('change');
        range.dispatchEvent(newevent);

      }

      initialRun(){
        let minVal = parseInt(this.priceInput[0].value),
            maxVal = parseInt(this.priceInput[1].value);
            if(minVal){
                this.rangeInput[0].value = minVal;
                const left_percentage = (parseInt(minVal) / parseInt(this.priceInput[1].max)) * 100;
                
                this.range.style.left = left_percentage + "%";
                
            }
            if(maxVal){
                this.rangeInput[1].value = maxVal;
                const range_percentage = parseInt(this.rangeInput[1].value) / parseInt(this.rangeInput[1].max) * 100;
                this.range.style.right = 100 - range_percentage + "%";
            }
            
      } 

      initialize() {

        this.initialRun();
        
        this.priceInput.forEach(input => {
            const debouncedChangeInput = debounce((e) => this.changeInput(e), 500);
            input.addEventListener("input", (e) => {
                this.changeProgress(e);
                return debouncedChangeInput(e);
            });
        });

        

        this.rangeInput.forEach(input => {
            input.addEventListener("input", e => this.changeProgress(e));
        });
      }

      get getActiveFilterUI() {
        return window.innerWidth <= 1023
          ? document.querySelector('[x-ref="filter-drawer"]')
          : document.querySelector('[x-ref="filter-sidebar"]');
      }

      
    });
}  */